const userDefinitionStyle = {
	
};

export default userDefinitionStyle;
